// extracted by mini-css-extract-plugin
export default {"headerContainer":"t3RgFFp_Uy4SGOdo0cDC"};